import * as Model from "../../model"

export function areBergerLevraultSettings(
	settings: ConnectorSettings
): settings is Model.BergerLevrault {
	return undefined !== (settings as Model.BergerLevrault).idCollectiviteGF
}

export type ConnectorSettings = Model.BergerLevrault



// WEBPACK FOOTER //
// ./src/domain/sfp/connector-domain.ts